const divSignUpTenantsCards = {
  header: 'Select your company: *',
  headerError: 'Select a company'
};

export default divSignUpTenantsCards;
